import React from 'react';

import {
  IHotelSelectOption,
  useSearchHotel,
} from '../../app/common/hooks/useSearchHotel';
import { filterOptions } from '../../app/common/sharedComponents/SearchBox/utils';
import { useTranslation } from 'react-i18next';
import { SearchBox } from '../../app/common/sharedComponents/SearchBox';
import { handleHotelOptionSelection } from './utils';

export function SearchBoxHotel ({ callBackSelectedOptions, disabled }) {
  const { t } = useTranslation();
  const {
    searchBoxOptions,
    selectedOptions,
    searchText,
    setSelectedOptions,
    setSearchText,
    setSearchBoxOptions,
  } = useSearchHotel();

  function handleInputChange (value: string) {
    setSearchText(value);
    const filteredOption = filterOptions(value, searchBoxOptions);
    setSearchBoxOptions(filteredOption);
  }

  function handleOptionClick (selected: IHotelSelectOption) {
    const selectedOption = handleHotelOptionSelection(
      selected,
      selectedOptions
    );
    if (selectedOption.length > 0) {
      callBackSelectedOptions([...selectedOptions, ...selectedOption]);
      setSelectedOptions([...selectedOptions, ...selectedOption]);
    }
  }

  function clearSearch () {
    setSearchText('');
    setSelectedOptions([]);
    callBackSelectedOptions([]);
  }

  return (
    <SearchBox
      handleInputChange={handleInputChange}
      searchBoxOptions={searchBoxOptions}
      handleOptionClick={handleOptionClick}
      selectedOptions={selectedOptions}
      searchTextName={searchText}
      clearSearch={clearSearch}
      placeholderText={t(
        'COMMON.MY_AUDIT.GENERIC_FIELDS.START_TYPING_TO_SELECT'
      )}
      label={t('COMMON.PROFILE.CV.HOTEL_NAME')}
      disabled={disabled}
    />
  );
}
